<template>
    <div>
        <!-- 添加编辑弹窗 -->
        <el-dialog class="dialog-box" :title="title" :visible.sync="formDialog" :close-on-click-modal="false">
            <!-- <el-scrollbar wrap-class="scrollbar-wrapper"> -->
                <el-form :model="formData" :rules="rulesForm" ref="ruleForm" label-width="150px" v-if="formDialog">
                    <!-- 是否合作 -->
                    <el-form-item class="form-item form-inline-item" label="是否合作" prop="type">
                        <el-select v-model="formData.isCooperate" placeholder="请选择" style="width:240px" clearable>
                            <el-option v-for="item in isCooperateOptions" :key="item.id" :label="item.name" :value="item.id"></el-option>
                        </el-select>
                    </el-form-item>
                   
                        <!-- 外包商名称 -->
                    <el-form-item class="form-item form-inline-item" label="外包商名称" prop="name">
                        <el-input v-model="formData.name" placeholder="请输入" style="width:240px"></el-input>
                    </el-form-item>
                    <!-- 外包商类型 -->
                    <el-form-item class="form-item form-inline-item" label="外包商类型" prop="type">
                        <el-select v-model="formData.type" placeholder="请选择" style="width:240px" clearable>
                            <el-option v-for="item in typesOptions" :key="item.id" :label="item.name" :value="item.id"></el-option>
                        </el-select>
                    </el-form-item>
                        <!-- 岗位分类  multiple  collapse-tags-->
                    <el-form-item class="form-item form-inline-item" label="岗位分类" prop='positionType'>
                        <el-select v-model="formData.positionType" placeholder="请选择" style="width:240px" clearable filterable multiple  collapse-tags>
                            <el-option v-for="item in postTypeOptions" :key="item.id" :label="item.name" :value="item.id"></el-option>
                        </el-select>
                    </el-form-item>
                        <!-- 是否已签新外包协议 -->
                    <el-form-item class="form-item form-inline-item" label="是否已签新外包协议" prop='isNewAgreement'>
                        <el-select v-model="formData.isNewAgreement" placeholder="请选择" style="width:240px" clearable>
                            <el-option v-for="item in isNewCollaboratorsOptions" :key="item.id" :label="item.name" :value="item.id"></el-option>
                        </el-select>
                    </el-form-item>

                 <!-- 入榜时间 -->
                    <el-form-item class="form-item form-inline-item" label="入榜时间">
                        <el-date-picker  v-model="formData.inListTimeStr" type="date" placeholder="请选择日期" format="yyyy-MM-dd" value-format="yyyy-MM-dd" style="width:240px"></el-date-picker>
                    </el-form-item>

                    <!-- 规模评级 -->
                    <el-form-item class="form-item form-inline-item" label="规模评级">
                        <el-select v-model="formData.grade" placeholder="请选择" style="width:240px">
                            <el-option v-for="item in gradesOptions" :key="item.id" :label="item.name" :value="item.id"></el-option>
                        </el-select>
                    </el-form-item>

                    <!-- 公司网址 -->
                    <el-form-item class="form-item form-inline-item" label="公司网址">
                        <el-input v-model="formData.website" placeholder="请输入" style="width:240px"></el-input>
                    </el-form-item>

                    <!-- 公司地址 -->
                    <el-form-item class="form-item form-inline-item" label="公司地址">
                        <el-input v-model="formData.address" placeholder="请输入" style="width:240px"></el-input>
                    </el-form-item>

                    <!-- 联系方式 -->
                    <el-form-item class="form-item form-inline-item" label="联系方式">
                        <el-input v-model="formData.telephone" placeholder="多个联系方式逗号分隔" style="width:240px"></el-input>
                    </el-form-item>

                    <!-- 作品集 -->
                    <el-form-item class="form-item form-inline-item" label="作品集">
                        <el-input v-model="formData.worksUrl" placeholder="可填写作品集链接" style="width:240px"></el-input>
                    </el-form-item>

                    <!-- 公司规模（人数） -->
                    <el-form-item class="form-item form-inline-item" label="公司规模（人数）">
                        <el-select v-model="formData.companySize" placeholder="请选择公司人数" style="width:240px" clearable>
                            <el-option v-for="item in companySizeOptions" :key="item.name" :label="item.name" :value="item.name"></el-option>
                        </el-select>
                    </el-form-item>

                    <!-- 人员结构 -->
                    <el-form-item class="form-item form-inline-item" label="人员结构">
                        <el-input v-model="formData.employeeComposition" placeholder="请输入" style="width:240px"></el-input>
                    </el-form-item>

                    <!-- 风格标签 -->
                    <el-form-item class="form-item form-inline-item" label="风格标签">
                        <el-select v-model="formData.styleLabel" placeholder="请选择" style="width:240px" multiple  collapse-tags clearable filterable>
                            <el-option v-for="item in styleLabelsOptions" :key="item.id" :label="item.name" :value="item.id"></el-option>
                        </el-select>
                    </el-form-item>

                    <!-- 技术特长 -->
                    <el-form-item class="form-item form-inline-item" label="技术特长">
                        <el-select v-model="formData.technology" placeholder="请选择" style="width:240px" multiple  collapse-tags clearable filterable>
                            <el-option v-for="item in technologysOptions" :key="item.id" :label="item.name" :value="item.id"></el-option>
                        </el-select>
                    </el-form-item>

                        <!-- 外单资源 -->
                    <el-form-item class="form-item form-inline-item" label="外单资源">
                        <el-input v-model="formData.outResources" placeholder="请输入" style="width:240px"></el-input>
                    </el-form-item>


                    <!-- 是否和英雄合作 -->
                    <el-form-item class="form-item form-inline-item" label="是否和英雄合作">
                        <el-select v-model="formData.isHeroCollaborator" placeholder="请选择" style="width:240px" @change="changeCollaborator">
                            <el-option v-for="item in isHeroCollaboratorsOptions" :key="item.id" :label="item.name" :value="item.id"></el-option>
                        </el-select>
                    </el-form-item>

                    <!-- 英雄项目 -->
                    <el-form-item class="form-item form-inline-item" label="英雄项目">
                        <el-select v-model="formData.heroProject" placeholder="请选择" style="width:240px" :disabled="formData.isHeroCollaborator != 1" multiple   clearable collapse-tags filterable>
                            <el-option v-for="item in projectOptions" :key="item.id" :label="item.name" :value="item.id"></el-option>
                        </el-select>
                    </el-form-item>

                       <!-- 市场对标竞品 -->
                    <el-form-item class="form-item form-inline-item" label="市场对标竞品">
                        <el-input v-model="formData.competitiveProducts" placeholder="请输入" style="width:240px"></el-input>
                    </el-form-item>


                    <!-- 参与过的项目 -->
                    <el-form-item class="form-item form-inline-item" label="参与过的项目">
                        <el-input v-model="formData.attendedProject" placeholder="多个项目逗号分隔" style="width:240px"></el-input>
                    </el-form-item>

                        <!-- 是否签新合同 -->
                    <el-form-item class="form-item form-inline-item" label="是否签新合同">
                        <el-select v-model="formData.isNewContract" placeholder="请选择" style="width:240px">
                            <el-option v-for="item in isNewContractOptions" :key="item.id" :label="item.name" :value="item.id"></el-option>
                        </el-select>
                    </el-form-item>

                    <!-- 总分 -->
                    <el-form-item class="form-item form-inline-item" label="总分">
                        <el-input v-model="formData.totalScore" placeholder="分值介于0-100" style="width:240px"></el-input>
                    </el-form-item>
                   
                    <!-- 素材链接 -->
                    <el-form-item class="form-item form-inline-item" label="素材链接">
                        <el-input v-model="formData.materialUrl" placeholder="请输入" style="width:240px"></el-input>
                    </el-form-item>

                     <!-- 备注 -->
                    <el-form-item class="form-item form-inline-item" label="备注">
                        <el-input v-model="formData.remarks" placeholder="请输入" style="width:240px"></el-input>
                    </el-form-item>

                </el-form>
            <!-- </el-scrollbar> -->

            <div slot="footer" class="dialog-footer">
                <!-- <el-button class="left-box button_upload" type="primary" @click="handleBatchUpload" v-if="source == 'add'">
                    <svg-icon icon-class="upload_shape" />
                    <span class="button_span">批量上传</span>
                </el-button> -->
                <div class="right-box">
                    <el-button class="button-primary-plain" size="small" @click="formDialog = false">取 消</el-button>
                    <el-button size="small" type="primary" @click="handleSave">确 定</el-button>
                </div>
            </div>
        </el-dialog>

        <!-- 批量上传弹窗 -->
        <batch-upload ref="batch"></batch-upload>

    </div>
   
</template>

<script>
import BatchUpload from './batchUpload.vue'
import { outsource_saveOutsourcer} from "@File~/api/outsourcing";

export default {
    components:{BatchUpload},
    data() {
        return {
            source:'',
            formDialog: false,
            title: '',
            formData: {
                "id":null,
                "name":"",
                "type":'',
                "positionType":[],
                "isNewAgreement":"",
                "inListTimeStr":"",
                
                "grade":'',
                "website":"",
                "address":"",
                "telephone":"",
                "worksUrl":"",
                "companySize":"",
                "employeeComposition":"",
                "styleLabel":[],
                "technology":[],
                "outResources":"",
                "isHeroCollaborator":"",
                "heroProject":[],
                "competitiveProducts":"",
                "attendedProject":"",
                "isNewContract":"",
                "totalScore":"" ,
                "materialUrl":"" ,
                "remarks":""
            },
            rulesForm:{
                type: [{ required: true, message: '请选择外包商类型', trigger: 'blur' }],
                // name: [{ required: true ,validator:(rule,value,callback)=>{
                //     return new Promise((resolve,reject)=>{
                //         console.log(rule)
                //         console.log(value)
                //         if(value){
                //             resolve();
                //         }else{
                //             // alert('123')
                //             console.log('333333')
                //             this.$message({type:'error',message:'外包商名称'})
                //             resolve();
                //         }
                //     })
                // }}],
                name: [{ required: true, message: '请输入外包商名称', trigger: 'change' }],
                isCooperate: [{ required: true, message: '请选择是否合作', trigger: 'change' }],
                positionType: [{ required: true, message: '请选择岗位分类', trigger: 'change' }],
                isNewAgreement: [{ required: true, message: '请选择是否已签新外包协议', trigger: 'change' }],
            },
            //新增属性
            postTypeOptions:[],
            isNewCollaboratorsOptions:[],
            isNewContractOptions:[{id:'1',name:'是'},{id:'-1',name:'否'}],
            styleLabelsOptions: [],
            technologysOptions: [],
            gradesOptions: [],
            projectOptions: [],
            typesOptions: [],
            isCooperateOptions: [],
            companySizeOptions: [{name:'1-100人'},{name:'101-500人'},{name:'501-1000人'},{name:'1001-3000人'},{name:'3001-5000人'},{name:'5000+人'},],
            isHeroCollaboratorsOptions: [{id:'1',name:'是'},{id:'-1',name:'否'}],

            rateOptions:[]
        }
    },
    methods: {
        changeCollaborator(){
            if(this.formData.isHeroCollaborator != 1){
                this.formData.heroProject = []
            }
        },
        // 初始化
        init(source,initData,row){
            this.source = source
            if(source == 'add') {
                this.title = '新增外包商'
                this.formData = {
                    "id":null,
                    "inListTimeStr":"",
                    "type":'',
                    "positionType":[],
                    "grade":'',
                    "name":"",
                    "website":"",
                    "address":"",
                    "telephone":"",
                    "worksUrl":"",
                    "companySize":"",
                    "employeeComposition":"",
                    "styleLabel":[],
                    "technology":[],
                    "isHeroCollaborator":"",
                    "heroProject":[],
                    "attendedProject":"",
                    "totalScore":"" ,
                    "materialUrl":"" ,
                }
            } else {
                this.title = '编辑外包商'
            }
            this.styleLabelsOptions = initData.styleLabelsOptions
            this.technologysOptions = initData.technologysOptions
            this.gradesOptions = initData.gradesOptions
            this.typesOptions = initData.typesOptions
            this.isCooperateOptions = initData.isCooperateOptions
            //新增岗位，是否已签新外包协议
            this.postTypeOptions = initData.postTypeOptions
            this.isNewCollaboratorsOptions = initData.isNewCollaboratorsOptions
            this.isHeroCollaboratorsOptions = initData.isHeroCollaboratorsOptions
            this.projectOptions = initData.projectOptions
        
            if(row){
                this.formData = JSON.parse(JSON.stringify(row));
                delete this.formData.modifyTime;
                this.formData.isHeroCollaborator +='';
                this.formData.type = this.formData.type?this.formData.type*1:'';
                this.formData.isCooperate = this.formData.isCooperate?this.formData.isCooperate*1:'';
                this.formData.positionType = this.formData.positionType?this.formData.positionType.split(',').map((item)=>{return parseInt(item)}):[];
                this.formData.isNewAgreement = this.formData.isNewAgreement?this.formData.isNewAgreement*1:'';
                this.formData.grade = this.formData.grade?this.formData.grade*1:'';
                this.formData.heroProject = this.formData.heroProject?this.formData.heroProject.split(',').map((item)=>{return parseInt(item)}):[];
                this.formData.styleLabel = this.formData.styleLabel?this.formData.styleLabel.split(',').map((item)=>{return parseInt(item)}):[];
                this.formData.technology = this.formData.technology?this.formData.technology.split(',').map((item)=>{return parseInt(item)}):[];
            }
            // this.formData = row?row:null
            // this.getProject()
            this.formDialog = true
        },
        

        updataFun(){
            let param = JSON.parse(JSON.stringify(this.formData));
            param.heroProject = param.heroProject.join(',')
            param.styleLabel = param.styleLabel.join(',')
            param.technology = param.technology.join(',')
            param.positionType = param.positionType.join(',')
        
             outsource_saveOutsourcer(param).then((response) => {
                 if(response.code == 1){
                     this.$parent.handleFilter()
                     this.$message({type:'success',message:'保存成功'})
                     this.formDialog = false;
                 }
             })
        },
    
        // 确定
        handleSave() {

            this.$refs.ruleForm.validate((valid) => {
                if(valid) {
                    this.updataFun()
                }
            })
        },

        // 批量上传
        handleBatchUpload() {
            this.$refs['batch'].init()
        }
    }
}
</script>

<style lang="scss" scoped>
    // 弹窗
.dialog-box {
  ::v-deep .el-dialog{
    min-width: 840px;
    width: 50vw;
    height: calc(100vh - 33vh);
    background: #FFFFFF;
    border-radius: 4px;
  }
  ::v-deep .el-dialog__header{
    padding: 26px 32px 24px;
  }
  ::v-deep .el-dialog__title{
    font-weight: 500;
    color: #333333;
  }
  ::v-deep .el-dialog__headerbtn{
    top: 18px;
    right: 28px;
    font-size: 24px;
  }
  ::v-deep .el-dialog__body{
    overflow: auto;
    padding: 16px 10px 16px 20px;
    height: calc(100vh - 35vh - 68px - 60px);
  }

  ::v-deep .el-scrollbar {
    //padding-right: 22px;
    height: 100%;
  }
  ::v-deep .el-scrollbar__wrap{
    overflow-x: auto;
  }

  ::v-deep .el-scrollbar__bar.is-vertical {
      right: 0px;
  }

  ::v-deep .el-form{
    margin-right: 16px;
    display: flex;
    flex-flow: row wrap;
    // justify-content: space-around;
  }
  .form-item{
    // margin-left:10px;
    // margin-right: 10px;
    .el-form-item__label{
      color: #666666;
      font-weight: 400;
    }
    .el-input__inner{
      background: #FFFFFF;
      box-shadow: 0px 2px 3px 0px rgba(0, 0, 0, 0.04);
      border-radius: 4px;
      border: 1px solid #E5E5E5;
      color: #333333;
    }
    .el-icon-arrow-up:before {
        content: "\E78F";
        color: #666;
    }
  }

  .dialog-footer{
    // display: flex;
    // flex-flow: row nowrap;
    // justify-content: space-between;
    padding: 0 32px 24px;

    .button-primary-plain{
      border: 1px solid #3A89FF;
      background: #FFFFFF;
      color: #3A89FF;
    }
    .el-button{
      font-size: 14px;
      padding: 11px 17px;
      border-radius: 4px;
    }
    .el-message-box__btns button:nth-child(2){
      margin-left: 12px;
    }

    .button_span{
      margin-left: 4px;
    }
    .left-box{
      float: left;
    }
    .right-box{
      float: right;
    }
  }

}

</style>

